import React from "react";
import cn from "classnames";

import { IWorkflowStep } from "store/workflows/workflows-types";

import Item from "./Item/Item";

import "./List.less";

interface Props {
    steps: ReadonlyArray<IWorkflowStep>;

    className?: string;
}

const List: React.FC<Props> = ({ steps, className }: Props) => {
    return (
        <ul className={cn("workflow-modal__steps", className)}>
            {[...steps]
                .sort((a, b) => a.order - b.order)
                .map((step) => (
                    <Item key={step.id} step={step} />
                ))}
        </ul>
    );
};

export default List;
